'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z' });

var RepeatOne = function RepeatOne(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

RepeatOne = (0, _pure2.default)(RepeatOne);
RepeatOne.muiName = 'SvgIcon';

exports.default = RepeatOne;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/RepeatOne.js
// module id = 2769
// module chunks = 0